import type { FaireProductEntity } from "../../entity_types/product";

export const p_ffpph5neym: FaireProductEntity = {
  token: "p_ffpph5neym",
  type: "product",
  name: "3D Printed Christmas Tree Twister Christmas Fidget Toy Gift",
  brandToken: "b_3zvyk2yn8q",
  brandName: "Little Trendy",
  imageUrl:
    "https://cdn.faire.com/fastly/d4bd06f0127a3d966cdc9c2b1d479ee0162a6e5969298fd90d92430a4a11438c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5c0dcfca2f725a14a71d166d33ae37ea821ac3f66c157feb767ec113429d8d02.jpeg",
    "https://cdn.faire.com/fastly/ef2279d6b997133cd319c53d179096d909f35da442861c14f69cd3a9a80a74b1.jpeg",
    "https://cdn.faire.com/fastly/98e9219c725fac8a332a7c0a6cbf31ed7f241d4d3002045f1c6d64525336d9cf.jpeg",
    "https://cdn.faire.com/fastly/ed7b40fd029b399b4ac3f59f1cdcd0bfd5dcfd591b0531dc7c59efd2228b22a3.jpeg",
    "https://cdn.faire.com/fastly/2afebcb7c45fd5163110823e29f1c6d9953fc91645200c18f0a2836dfca50f0a.jpeg",
    "https://cdn.faire.com/fastly/59967ff39b63ec4f4ae220881de9375d9c9c60db7a7ae60a12b8629faec06dd6.jpeg",
    "https://cdn.faire.com/fastly/0cdabb51e9c20ef01fa2a466b734e339fd39d6cb06faab0a287609dffea227fc.jpeg",
    "https://cdn.faire.com/fastly/f4cfee3ebce7c60e887d8f44bd655a4a3150bc1a0836cb5814030874897222aa.jpeg",
  ],
  priceDollars: 3.99,
  description:
    "Material:PLA\nProcess:3D printing\nShape:Christmas tree\nManufacturing method:3D printing\nColor/Size:Large (8 x 5.5 cm)\n\n3D Printed Christmas Tree Twister Christmas Fidget Toy Gift\n3D Printed Christmas Tree Twister Christmas Fidget Toy Gift",
  tags: [],
  msrpDollars: 7.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:17.458Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
